import gql from 'graphql-tag';

export const FRAGMENT_APP = gql`
  fragment app on ContentSnippetAppType {
    appComponentId
    app {
      description
      id
      title
      files {
        appComponentId
        fileType
        id
        locationId
      }
    }
  }
`;
